import { Icon, type IconName, Text } from '@lubehub/ui-web';
import { Link } from 'react-router';

import { t } from '../copy';
import { PUBLIC_PATHS } from '../legal/identity';
import { usePublicLocale } from '../locale';

const DESTINATIONS: { to: string; label: string; body: string; icon: IconName }[] = [
  { to: PUBLIC_PATHS.privacy, label: 'nav.privacy', body: 'home.card.privacy', icon: 'shield' },
  { to: PUBLIC_PATHS.terms, label: 'nav.terms', body: 'home.card.terms', icon: 'list' },
  { to: PUBLIC_PATHS.support, label: 'nav.support', body: 'home.card.support', icon: 'chat' },
  {
    to: PUBLIC_PATHS.accountDeletion,
    label: 'nav.deletion',
    body: 'home.card.deletion',
    icon: 'trash',
  },
];

/**
 * The public front page: what CarCarNa is, who runs it, and the four things a
 * visitor comes here for. Each destination is one card that is the link.
 */
export function HomePage() {
  const { locale } = usePublicLocale();

  return (
    <div className="public-page">
      <section className="public-hero">
        <span className="public-hero__mark" aria-hidden="true">
          <Icon name="car" size={32} />
        </span>
        <Text as="h1" variant="display">
          {t(locale, 'home.title')}
        </Text>
        <Text variant="titleLg" as="p">
          {t(locale, 'home.subtitle')}
        </Text>
        <Text variant="body" tone="secondary" as="p">
          {t(locale, 'home.lead')}
        </Text>
        <Text variant="bodySm" tone="muted" as="p">
          {t(locale, 'home.operator')}
        </Text>
      </section>

      <ul className="public-cards">
        {DESTINATIONS.map((destination) => (
          <li key={destination.to}>
            <Link
              to={destination.to}
              className="public-card"
              aria-labelledby={`card-${destination.label}`}
              aria-describedby={`card-${destination.body}`}
            >
              <span className="lh-icon-tile" aria-hidden="true">
                <Icon name={destination.icon} size={18} />
              </span>
              <span className="public-card__text">
                <span className="public-card__title" id={`card-${destination.label}`}>
                  {t(locale, destination.label)}
                </span>
                <span className="public-card__body" id={`card-${destination.body}`}>
                  {t(locale, destination.body)}
                </span>
              </span>
              <span className="public-card__go" aria-hidden="true">
                <Icon name="arrow" size={18} />
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
